<template>
    <div class="related-data">
        <a-button @click="manageLabel" class="label-manage" type="primary">
        标签管理
        </a-button>
        <a-modal :centered='true' :maskClosable='false' :closable='false' v-model.trim="tagListBool" footer='' width='440px'>
            <div class="delete-modal modal-public">
                <div class="modal-title">
                    <span>标签</span>
                    <a-icon @click="hideTagBox" class="coordination-search-close" type="close" />
                </div>
                <div class='tag-box'>
                    <div class="new-add-tags">
                        <a-button @click="newTags" class="coordination-search-button" icon="plus">
                        新建标签
                        </a-button>
                    </div>
                    <div class="coordination-search">
                        <a-icon class="coordination-search-icon" type="search" />
                        <a-input @change="queryTagList()" class="coordination-search-input" v-model="filterTagName" placeholder="搜索标签" />
                    </div>
                    <div class="tag-list">
                        <ul>
                            <li v-for="(item,index) in tagListData" :key='index' :style="{'color':item.color}">
                                <a-icon class="tag-icon" type="tag" />
                                <span class="tag-name">{{item.name}}</span>
                                <div class="btn-group">
                                    <a-icon @click="editTag(item.id,item.name)" type="edit" />
                                    <a-icon @click="ifDeleteTag(item.id)" type="delete" />
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </a-modal>
        <a-modal :centered='true' :maskClosable='false' v-model.trim="newTagModal" :closable='false' footer='' width='480px'>
            <div class="add-new-data-modal">
                <div class="add-title">
                    <span>新增标签</span>
                    <a-icon @click="cancelNewTag" type="close" />
                </div>
                <div class="add-data" style="padding-right:24px;padding-top:30px">
                    <a-input v-model="tagName" placeholder="请输入标签名" />
                </div>
                <div class="btn-group">
                    <div>
                        <a-button type="default" @click="cancelNewTag">取消</a-button>
                        <a-button type="primary" @click="sureNewTag">确认</a-button>
                    </div>
                </div>
            </div>
        </a-modal>
        <a-modal :centered='true' :maskClosable='false' v-model.trim="deleteTagModal" :closable='false' footer='' width='480px'>
            <div class="add-new-data-modal">
                <div class="add-title">
                    <span>确认删除</span>
                    <a-icon @click="cancelDeleteTag" type="close" />
                </div>
                <div class="add-data">
                    <a-icon type="question-circle" />
                    <span>您确定要删除这个标签？</span>
                </div>
                <div class="btn-group">
                    <div>
                        <a-button type="default" @click="cancelDeleteTag">取消</a-button>
                        <a-button type="primary" @click="sureDeleteTag">确认</a-button>
                    </div>
                </div>
            </div>
        </a-modal>
    </div>
</template>

<script>
export default {
    data(){
        return{
            tagListBool: false,
            newTagModal: false,
            currentTagId: '',
            tagName: '',
            moduleId: '',
            deleteTagModal: false,
            filterTagName: '',
            tagListData: [],
        }
    },
    methods: {
        manageLabel() {
            this.tagListBool = true
            this.moduleId = this.$parent.moduleId
            this.queryTagList()
            console.log(this.moduleId)
        },
        hideTagBox() {
            this.tagListBool = false
        },
        newTags() {
            this.newTagModal = true
            this.currentTagId = ''
        },
        cancelNewTag() {
            this.newTagModal = false
            this.tagName = ''
        },
        sureNewTag() {
            this.newTagModal = false
            this.axios.post('/api/label', {
                moduleId: this.moduleId,
                id: this.currentTagId,
                name: this.tagName
            })
            .then(response=> {
                if(response.data.code == 0){
                    this.tagName = ''
                    this.queryTagList()
                    this.$emit('queryTagList')
                }else{
                    this.$message.error(response.data.userTip);
                }
            })
            .catch(error=> {
                console.log(error);
            });
        },
        ifDeleteTag(id) {
            this.deleteTagModal = true
            this.currentTagId = id
        },
        cancelDeleteTag() {
            this.deleteTagModal = false
        },
        sureDeleteTag() {
            this.deleteTagModal = false
            this.axios.delete('/api/label/'+this.currentTagId,{
                params: {
                    id: this.currentTagId,
                }
            })
            .then(response=> {
                if(response.data.code == 0){
                    this.queryTagList()
                    this.$emit('queryTagList')
                }else{
                    this.$message.error(response.data.userTip);
                }
            })
            .catch(error=> {
                console.log(error);
            });
        },
        editTag(id, name) {
            this.currentTagId = id
            this.tagName = name
            this.newTagModal = true
        },
        queryTagList() {
            this.axios(
                {
                    method:'get',
                    url:'/api/label/list', 
                    params: {
                        moduleId: this.moduleId,
                        name: this.filterTagName,
                    }
                }
            )
            .then(response=> {
                if(response.data.code == 0){
                    this.tagListData = response.data.data
                }else{
                    this.$message.error(response.data.userTip);
                }
            })
            .catch(error=> {
                console.log(error)
            })
        },
    },
    mounted: function() {
        
    }
}
</script>
<style scoped lang="less">
    .related-data{
        display: inline-block;
        .label-manage{
            height: 26px;
        }
    }
    .tag-box{
        // position: absolute;
        // right: 55px;
        // top: 50px;
        z-index: 1000;
        background: #fff;
        padding-top: 12px;
        // width: 240px;
        box-shadow: 0px 2px 16px 0px rgba(0, 0, 0, 0.12);
        height: 300px;
        .new-add-tags{
            height: 48px;
            position: relative;
            .coordination-search-button{
                float: right;
                height: 28px;
                line-height: 28px;
                background: rgba(158, 172, 196, 0.12);
                color: rgba(158, 172, 196, 1);
                margin-right: 20px;
                text-align: center;
                border: none;
            }
            .coordination-search-close{
                position: absolute;
                right: 5px;
                top: 0px;
                cursor: pointer;
                color: #9eacc4;
            }
        }
        .coordination-search{
            position: relative;
            padding: 0 20px;
            .coordination-search-icon{
                position: absolute;
                top: 9px;
                left: 30px;
                z-index: 10;
                color: rgba(158, 172, 196, 0.7);
            }
            .coordination-search-input{
                width: 100%;
                height: 32px;
                padding-left: 30px;
            }
        }
        .tag-list{
            height: 200px;
            overflow-y: auto;
            padding: 0 20px;
            li{
                height: 44px;
                line-height: 44px;
                cursor: pointer;
                padding-left: 16px;
                padding-right: 8px;
                text-align: left;
                .tag-icon{
                    font-size: 16px;
                }
                .tag-name{
                    font-size: 13px;
                    margin-left: 8px;
                }
                div{
                    float: right;
                    display: none;
                    i{
                        color: rgba(158, 172, 196, 0.7);
                        font-size: 12px;
                    }
                    i:nth-child(1){
                        margin-right: 8px;
                    }
                }
            }
            li:hover{
                background: rgba(240, 242, 243, 0.5);
                div{
                    display: inline-block;
                }
            }
        }
    }
    .modal-public{
        .modal-title{
            height: 55px;
            border-bottom: 1px solid rgba(229, 229, 229, 1);
            padding: 20px 20px 0 24px;
            span{
                color: rgba(18, 18, 18, 1);
                font-size: 14px;
                font-weight: bold;
            }
            i{
                color: rgba(158, 172, 196, 1);
                float: right;
                font-size: 16px;
                cursor: pointer;
            }
        }
        .modal-info{
            padding: 16px 20px 24px 24px;
            .modal-content{
                flex: 1;
                margin-left: 20px;
                .modal-tip{
                    color: rgba(18, 18, 18, 1);
                    font-size: 16px;
                }
                .modal-des{
                    color: rgba(158, 172, 196, 1);
                    font-size: 13px;
                    margin-top: 12px;
                }
            }
        }
        .btn-group{
            text-align: right;
            padding: 0 20px 20px 0;
            button{
                width: 64px;
                height: 28px;
                font-size: 13px;
                text-align: center;
            }
            button:nth-child(1){
                margin-right: 8px;
                color: rgba(158, 172, 196, 1);
                border: none;
            }
            button:nth-child(2){
                color: #fff;
                background: rgba(58, 220, 255, 1);
            }
        }
    }
    .delete-modal{
        .modal-info{
            display: flex;
            i{
                color: rgba(255, 170, 0, 1);
                font-size: 24px;
            }
        }
    }
    .add-new-data-modal{
        .add-title{
            padding: 20px 20px 14px 24px;
            span{
                color: rgba(18, 18, 18, 1);
                font-size: 14px;
                font-weight: bold;
            }
            i{
                float: right;
                color: rgba(158, 172, 196, 1);
                font-size: 16px;
                cursor: pointer;
            }
        }
        .add-data{
            border-top: 1px solid rgba(229, 229, 229, 1);
            padding: 16px 0 24px 24px;
            i{
                color: rgba(255, 170, 0, 1);
                font-size: 20px;
                margin-right: 20px;
            }
            span{
                color: rgba(18, 18, 18, 1);
                font-size: 16px;
            }
        }
        .btn-group{
            padding: 0 20px 20px 0;
            height: 48px;
            div{
                float: right;
            }
            button{
                display: inline-block;
                width: 64px;
                height: 28px;
                margin-left: 8px;
                font-size: 13px;
            }
            button:nth-child(1){
                color: rgba(158, 172, 196, 1);
            }
        }
    }
</style>